{
  "alert.informative": "Informative",
  "alert.negative": "Negative",
  "alert.notice": "Notice",
  "alert.positive": "Positive",
  "chat.newMessage": "Nová zpráva",
  "chat.scrollToBottom": "Posunout dolů",
  "messagefeedback.thumbDown": "Špatná odpověď",
  "messagefeedback.thumbUp": "Dobrá odpověď",
  "promptfield.aiDisclaimer": "Odpovědi se generují pomocí AI a mohou být nepřesné. Před použitím zkontrolujte.",
  "promptfield.aiUserGuidlines": "Pokyny pro uživatele AI",
  "promptfield.attachments": "Přílohy",
  "promptfield.insertButton": "Přidat",
  "promptfield.label": "Výzva",
  "promptfield.placeholder": "Jste připraveni začít? Položte otázku, podělte se o svůj nápad nebo přidejte úkol.",
  "promptfield.placeholder.small": "Ask anything",
  "promptfield.stopButton": "Zastavit",
  "promptfield.submitButton": "Odeslat",
  "promptfield.uploading": "Nahrávání",
  "responsestatus.loading": "Načítání",
  "responsestatus.processing": "Processing...",
  "voicebutton.startListening": "Začít nahrávat",
  "voicebutton.stopListening": "Zastavit nahrávání",
  "attachmentlist.previousAttachments": "Show previous attachments",
  "attachmentlist.nextAttachments": "Show next attachments"
}
